import { Vue, newVue, initVue } from '@/config/vue'

const init = () => {
  const Navigation = Vue.component('navigation', () =>
    import(/* webpackChunkName: "navigation" */ './Navigation.vue')
  )
  newVue({
    render: h => h(Navigation),
    mount: 'header',
  })
}
window.On.NavigationVueInit = init

initVue({
  init({ isCheckout, isSpa }) {
    if (!isCheckout && !isSpa) init()
  },
})
